import type { AccountProviderType } from 'owa-accounts-store';
import loc from 'owa-localize';
import { outlookProviderExtended, googleProvider, iCloudProvider } from '../strings.locstring.json';

export default function getAccountProviderTypeExtendedLabel(type: AccountProviderType): string {
    switch (type) {
        case 'Outlook':
            return loc(outlookProviderExtended);
        case 'Google':
            return loc(googleProvider);
        case 'ICloud':
            return loc(iCloudProvider);
        default:
            return null;
    }
}
